import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { token } from "../theme/tokens.js";
export function GalleryPagination({ page, pageSize, total, onPageChange }) {
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    const isFirst = page <= 1;
    const isLast = page >= totalPages;
    if (totalPages <= 1)
        return null;
    const containerStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        padding: "16px 0",
    };
    const buttonStyle = (disabled) => ({
        padding: "6px 14px",
        fontSize: "13px",
        fontWeight: 500,
        border: `1px solid ${token("cardBorder")}`,
        borderRadius: "6px",
        background: disabled ? "transparent" : token("cardBg"),
        color: disabled ? token("metaColor") : token("titleColor"),
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
    });
    const infoStyle = {
        fontSize: "13px",
        color: token("metaColor"),
    };
    return (_jsxs("nav", { style: containerStyle, "aria-label": "Gallery pagination", children: [_jsx("button", { style: buttonStyle(isFirst), disabled: isFirst, onClick: () => onPageChange(page - 1), "aria-label": "Previous page", children: "\u2190 Previous" }), _jsxs("span", { style: infoStyle, children: ["Page ", page, " of ", totalPages] }), _jsx("button", { style: buttonStyle(isLast), disabled: isLast, onClick: () => onPageChange(page + 1), "aria-label": "Next page", children: "Next \u2192" })] }));
}
//# sourceMappingURL=GalleryPagination.js.map